import { Router, UrlSegment } from '@angular/router';
import { inject } from '@angular/core';
import { removeLastSlash } from '@lentau/ui-kit/core/utils/url.utils';

export const getSegmentsFromRoot = (): UrlSegment[] => {
  const router: Router = inject(Router);
  return router.parseUrl(router.url).root.children.primary?.segments;
};

export const getUrlWithoutParamsFn = (): (() => string) => {
  const segments: UrlSegment[] = getSegmentsFromRoot();
  return () => segments.map((it: UrlSegment) => it.path).join('/');
};

export const getParamsForRouterNavigate = (url: string): { path: string; queryParams: { [key: string]: string } } => {
  const urlParts: string[] = url.split('?');
  const path: string = urlParts[0];
  const queryParams: Record<string, string> = {};

  if (urlParts.length > 1) {
    const params: string[] = urlParts[1].split('&');
    params.forEach((param: string) => {
      const [key, value]: string[] = param.split('=');
      queryParams[key] = decodeURIComponent(removeLastSlash(value));
    });
  }

  return { path, queryParams };
};
